import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "../../axiosClient/userApi";

type DeleteTagValueArgs = {
    tagValueId: string;
    /**
     * When true, sends `?force=true` so the backend strips orphaned
     * references from every taggable entity before deleting the value.
     * Used by the "delete anyway" path of the in-use confirmation modal.
     */
    force?: boolean;
};

export const useDeleteTagValue = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ tagValueId, force = false }: DeleteTagValueArgs): Promise<void> => {
            const url = force ? `/api/tag_values/${tagValueId}?force=true` : `/api/tag_values/${tagValueId}`;
            await loggedInApiCall.delete(url);
        },
        onSuccess: () => {
            queryClient.invalidateQueries(["getAllTagValues"]);
            queryClient.invalidateQueries(["getAllEntityTags"]);
        },
    });
};
